import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../../../web/components-v2/Button';
import {
	Dialog,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../../../../web/components-v2/Dialog';
import { styleSheet } from './styles';

interface CustomSystemMessageModalProps {
	isOpen: boolean;
	onClose: () => void;
	message: string;
	onMessageChange: (message: string) => void;
	onSave: () => void;
}

export const CustomSystemMessageModal: React.FC<CustomSystemMessageModalProps> = ({
	isOpen,
	onClose,
	message,
	onMessageChange,
	onSave,
}) => {
	const [localMessage, setLocalMessage] = React.useState(message);

	// Update local state when message prop changes
	React.useEffect(() => {
		setLocalMessage(message);
	}, [message]);

	const handleSave = () => {
		onMessageChange(localMessage);
		onSave();
		onClose();
	};

	const handleCancel = () => {
		setLocalMessage(message); // Reset to original value
		onClose();
	};

	const handleClear = () => {
		setLocalMessage('');
	};

	return (
		<Dialog open={isOpen} onOpenChange={handleCancel}>
			<DialogPopup>
				<DialogHeader>
					<DialogTitle>Custom Survey Message</DialogTitle>
					<DialogDescription>
						Add custom instructions for the AI analysis. This will override the default analysis type message.
					</DialogDescription>
				</DialogHeader>
				<div className={css(styleSheet.content)}>
					<textarea
						value={localMessage}
						onChange={e => setLocalMessage(e.target.value)}
						placeholder='Enter custom instructions for the AI analysis...'
						className={css(styleSheet.textarea)}
						rows={8}
						maxLength={2000}
					/>
					<div className={css(styleSheet.characterCount)}>{localMessage.length} / 2000 characters</div>
				</div>
				<DialogFooter>
					<div className={css(styleSheet.footer)}>
						<Button variant='secondary' onClick={handleClear} disabled={!localMessage.trim()}>
							Clear
						</Button>
						<div className={css(styleSheet.footerActions)}>
							<Button variant='secondary' onClick={handleCancel}>
								Cancel
							</Button>
							<Button onClick={handleSave}>Save</Button>
						</div>
					</div>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
